import React, { useState, useEffect, FC } from 'react';
import './HomePage.css';
import { Link } from 'react-router-dom';

// Import images from the src directory
import s1 from './s1.jpg';
import s2 from './s2.jpg';
import s3 from './s3.jpg';
import logo from './vkslogo.png'; // Import your logo file

// Assuming your images are in the public/images folder
const images: string[] = [
  s1,
  s2,
  s3,
];

const HomePage: FC = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => {
      // Automatically move to the next slide
      showNextSlide();
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [currentIndex]); // Reset timer whenever currentIndex changes

  const showPrevSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + images.length) % images.length);
  };

  const showNextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
  };

  return (
    <div className="home-page">
      <header className="header">
        <Link to="/" className="logo-link">
          <img src={logo} alt="Company Logo" className="logo" />
        </Link>
        {/* Use Link for client-side navigation */}
        <Link to="/login" className="login-button">
          Login
        </Link>
      </header>

      <main>
        <div className="carousel-container">
          <div
            className="carousel-wrapper"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {images.map((img: string, index: number) => (
              <div className="carousel-slide" key={index}>
                <img src={img} alt={`Slide ${index + 1}`} />
              </div>
            ))}
          </div>
          {/* Arrow Buttons */}
          <button className="carousel-button prev" onClick={showPrevSlide}>&#10094;</button>
          <button className="carousel-button next" onClick={showNextSlide}>&#10095;</button>
        </div>
      </main>
      <footer style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 40px', color: '#333', lineHeight: '1.6' }}>
        <div style={{ flex: 1, textAlign: 'center', fontSize: '1.0em' }}>
          Email: vks@gmail.com<br />
          Mobile: 97515 50566<br />
          Address: Door No. 4/50-3, Nambiyur,Pulliyampatti Road,VemandamPalayam, Pin-638462.
        </div>
        <div style={{ fontSize: '0.8em', color: '#666', textAlign: 'right' }}>
          Copyright © 2025 VKS OIL MILLS.<br />
          All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default HomePage;